<template>
  <div class="collapse">
    <div
      :class="{
        'collapse-item': true,
        'is-active': activeNames.indexOf(index) > -1,
      }"
      v-for="(item, index) in filterList"
      :key="index"
    >
      <div
        class="collapse-item-tab"
        @click.prevent="handleChange($event, index)"
      >
        {{ item.title }}
        <i v-show="activeNames.indexOf(index) > -1" class="active-icon"></i>
        <i v-show="activeNames.indexOf(index) == -1" class="close-icon"></i>
      </div>
      <transition
        name="qa"
        @enter="enter"
        @after-enter="afterEnter"
        @leave="leave"
        @after-leave="afterLeave"
      >
        <div
          class="collapse-item-wrap"
          v-show="activeNames.indexOf(index) > -1"
        >
          <div class="collapse-item-content" v-html="item.content"></div>
        </div>
      </transition>
    </div>
    <div v-if="!loadAll" class="load-more">
      <div class="load-more-text" @click.prevent="loadAll = true">
        查看更多
        <i class="close-icon"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Collapse",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeNames: [-1],
      loadAll: false,
    };
  },
  computed: {
    filterList() {
      if (this.list.length == 0) return [];
      if (this.loadAll) {
        return this.list;
      } else {
        return this.list.slice(0, 3);
      }
    },
  },
  mounted() {},
  methods: {
    handleChange(e, index) {
      let curIndex = this.activeNames.indexOf(index);
      if (curIndex > -1) {
        this.activeNames.splice(curIndex, 1);
      } else {
        this.activeNames.splice(0, 0, index);
      }
    },
    enter(el) {
      el.style.setProperty("--h", `${el.scrollHeight}px`);
    },
    afterEnter(el) {
      el.removeAttribute("style");
    },
    leave(el) {
      el.style.setProperty("--h", `${el.scrollHeight}px`);
    },
    afterLeave(el) {
      el.style.setProperty("--h", "");
    },
  },
};
</script>
<style lang="less" scoped>
.collapse {
  // border: 2/100rem solid #f0f0f0;
  .collapse-item {
    font-size: 24/100rem;
    color: #404040;
    &:last-child {
      .collapse-item-tab {
        border-bottom: transparent;
      }
    }
    .collapse-item-tab {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 86/100rem;
      padding: 26/100rem 27/100rem 26/100rem 19/100rem;
      border-bottom: 1px solid #f0f0f0;
      background-color: #fff;
      outline: none;
      cursor: pointer;
      .active-icon,
      .close-icon {
        width: 22/100rem;
        height: 22/100rem;
      }
      .active-icon {
        background: url(../assets/maintenance/down-arrow-icon.png) no-repeat
          center center;
        background-size: cover;
      }
      .close-icon {
        background: url(../assets/maintenance/right-arrow-icon.png) no-repeat
          center center;
        background-size: cover;
      }
    }
    .collapse-item-wrap {
      // padding: 27/100rem;
      will-change: height;
      overflow: hidden;
      border-bottom: 1px solid #f0f0f0;
      .collapse-item-content {
        color: #404040;
        padding: 26/100rem;
        text-indent: 2ch;
      }
    }
    .qa-enter-active {
      animation: qa-in 0.3s ease-in-out;
    }
    .qa-leave-active {
      animation: qa-out 0.3s ease-in-out;
    }
  }
  .load-more {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #a1a1a1;
    font-size: 24/100rem;
    height: 86/100rem;
    .load-more-text {
      align-items: center;
      display: flex;
      .close-icon {
        width: 20/100rem;
        height: 20/100rem;
        background: url(../assets/maintenance/right-arrow-icon.png) no-repeat
          center center;
        background-size: cover;
      }
    }
  }
}
@keyframes qa-in {
  0% {
    height: 0;
  }
  100% {
    height: var(--h);
  }
}
@keyframes qa-out {
  0% {
    height: var(--h);
  }
  100% {
    height: 0;
  }
}
</style>
